const keyFor = userId => `audit-pro:last-audit:${userId}`;
export function rememberAudit(userId, auditId) {
  if (!userId || !Number.isSafeInteger(Number(auditId)) || Number(auditId) < 1) return;
  try { localStorage.setItem(keyFor(userId), String(auditId)); } catch { /* Optional navigation preference. */ }
}
export function recentAvailableAudit(userId, audits = []) {
  let id;
  try { id = localStorage.getItem(keyFor(userId)); } catch { return null; }
  // Never use the saved identifier to infer access or fetch an old account's data.
  return audits.find(audit => String(audit.id) === id) || null;
}
